module.exports = __webpack_public_path__ + "img/smallEyeDodIcon.74e66214.svg";